import { useEffect, useRef, useState } from 'react'

export const useResizeObserver = (
  refs: Array<React.MutableRefObject<null>>,
  callback: (entries: ResizeObserverEntry[]) => void,
) => {
  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      callback(entries)
    })

    for (const ref of refs) {
      if (ref.current !== null) {
        resizeObserver.observe(ref.current)
      }
    }

    return () => {
      resizeObserver.disconnect()
    }
  }, [])
}

// 返り値のrefを使ったDOMのサイズを監視するhook
export const useResize = () => {
  const [rect, setRect] = useState<DOMRectReadOnly | undefined>(undefined)
  const ref = useRef(null)
  useResizeObserver([ref], (entries) => {
    const entry = entries[0]
    if (entry === undefined) {
      return
    }
    setRect(entry.contentRect)
  })

  return {
    ref,
    rect,
  }
}
